import { render } from "./CommentsPopUp.vue?vue&type=template&id=73188353&scoped=true&ts=true"
import script from "./CommentsPopUp.vue?vue&type=script&lang=ts"
export * from "./CommentsPopUp.vue?vue&type=script&lang=ts"

import "./CommentsPopUp.vue?vue&type=style&index=0&id=73188353&scoped=true&lang=sass"

import exportComponent from "/home/casedrive/releases/front/108/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73188353"]])

export default __exports__